import { getLayoutState, useSelector } from '../store'
import AccountMenu from './AccountMenu'
import SubscriptionPlanBanner from './SubscriptionPlanBanner'

export interface MainContainerProps {
  children: any
}

const MainContainer = ({ children = [] }: MainContainerProps) => {
  const { sideBarCollapsed } = useSelector(getLayoutState)
  return (
    <div>
      <div
        style={{
          height: '80px',
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 15,
          backgroundColor: '#2E2F3C',
        }}
      >
        <div
          className={`
          h-full flex flex-col-reverse
          items-start
          transition-all
          duration-500
          md:flex-row
          md:justify-between
          md:items-center
          mainHeaderBanner`}
        >
          <SubscriptionPlanBanner />
          <AccountMenu />
        </div>
      </div>

      <div
        className={`transition-all duration-500 bg-white p-5 sm:p-10 relative ml-24 ${
          !sideBarCollapsed && 'sm:ml-64'
        }`}
        style={{
          height: 'calc(100vh - 100px)',
          paddingTop: '130px',
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default MainContainer
